// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  InitialTrueUpsForAllCurrencies,
  SavedAccountingPeriod,
} from '@/accounting/api/types';

/** Finds the earliest period any currency was trued up in, or null before the first initial true-up. */
export function findEarliestInitialTrueUpPeriod(
  initialTrueUps: InitialTrueUpsForAllCurrencies | null
): SavedAccountingPeriod | null {
  let earliestPeriod: SavedAccountingPeriod | null = null;
  for (const initialTrueUp of initialTrueUps?.initialTrueUps ?? []) {
    const period = initialTrueUp.accountingPeriod;
    if (
      earliestPeriod === null ||
      period.year < earliestPeriod.year ||
      (period.year === earliestPeriod.year &&
        period.month < earliestPeriod.month)
    ) {
      earliestPeriod = period;
    }
  }

  return earliestPeriod;
}
